import React, { useState } from 'react';
import Locale from '../locales/en/contact';

// markup mostly from Mailchimp form builder, adapted to JSX
const MailchimpSignupForm = () => {
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [company, setCompany] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');

  return (
    <div id="mc_embed_signup">
      <form
        action="https://cnycn.us18.list-manage.com/subscribe/post?u=b3d80e8a36c3f42016cebbc93&amp;id=8c8a2c27cf"
        method="post"
        id="mc-embedded-subscribe-form"
        name="mc-embedded-subscribe-form"
        className="validate"
      >
        <div id="mc_embed_signup_scroll">
          <div className="mc-field-group">
            <label htmlFor="mce-FNAME">
              <span>{Locale.firstName}</span>
              <input
                type="text"
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
                name="FNAME"
                id="mce-FNAME"
              />
            </label>
          </div>
          <div className="mc-field-group">
            <label htmlFor="mce-LNAME">
              <span>{Locale.lastName}</span>
              <input
                type="text"
                name="LNAME"
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
                id="mce-LNAME"
              />
            </label>
          </div>
          <div className="mc-field-group">
            <label htmlFor="mce-EMAIL">
              <span>{Locale.email}</span>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                name="EMAIL"
                className="required email"
                id="mce-EMAIL"
                pattern=".+@.+"
                required
              />
            </label>
          </div>
          <div className="mc-field-group">
            <label htmlFor="mce-PHONE">
              <span>{Locale.phoneNumber}</span>
              <input
                type="text"
                name="PHONE"
                value={phoneNumber}
                placeholder="e.g. 555-555-5555"
                onChange={(e) => setPhoneNumber(e.target.value)}
                id="mce-PHONE"
              />
            </label>
          </div>
          <div className="mc-field-group">
            <label htmlFor="mce-MMERGE5">
              <span>{Locale.company}</span>
              <input
                type="text"
                value={company}
                onChange={(e) => setCompany(e.target.value)}
                name="MMERGE5"
                id="mce-MMERGE5"
              />
            </label>
          </div>
          <div id="mce-responses" className="clear">
            <div
              className="response"
              id="mce-error-response"
              style={{ display: 'none' }}
            />
            <div
              className="response"
              id="mce-success-response"
              style={{ display: 'none' }}
            />
          </div>
          <div style={{ position: 'absolute', left: '-5000px' }} aria-hidden="true">
            <input
              type="text"
              name="b_b3d80e8a36c3f42016cebbc93_8c8a2c27cf"
              tabIndex="-1"
              value=""
              readOnly
            />
          </div>
          <div className="clear">
            <input
              type="submit"
              value="Sign Up"
              name="sign-up"
              id="mc-embedded-subscribe"
              className="button"
            />
          </div>
        </div>
      </form>
    </div>
  );
};

export default MailchimpSignupForm;
